// extracted by mini-css-extract-plugin
module.exports = {"item":"albums-module--item--3wnwR"};